export const fmtTimeAgo = (date, t) => {
  if (!date) return '';
  const diff = (Date.now() - new Date(date)) / 1000;
  if (diff < 60) return t ? t('qoreConnect.time.justNow') : 'Just now';
  if (diff < 3600) return t('qoreConnect.time.minutesAgo', { count: Math.floor(diff / 60) });
  if (diff < 86400) return t('qoreConnect.time.hoursAgo', { count: Math.floor(diff / 3600) });
  if (diff < 604800) return t('qoreConnect.time.daysAgo', { count: Math.floor(diff / 86400) });
  return new Date(date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const fmtEventDate = (date) => {
  if (!date) return { day: '--', month: '---' };
  const d = new Date(date);
  return {
    day: d.getDate(),
    month: d.toLocaleDateString(undefined, { month: 'short' }),
  };
};